import { render, staticRenderFns } from "./ColorSwatch.vue?vue&type=template&id=2e2102b2&scoped=true"
import script from "./ColorSwatch.vue?vue&type=script&lang=js"
export * from "./ColorSwatch.vue?vue&type=script&lang=js"
import style0 from "./ColorSwatch.vue?vue&type=style&index=0&id=2e2102b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e2102b2",
  null
  
)

export default component.exports